const STORAGE_KEY = 'dopms_auth'

export function getAuth () {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (!data || typeof data.roleid !== 'number') return null
    return data
  } catch {
    return null
  }
}

export function setAuth (user) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(user))
}

export function clearAuth () {
  sessionStorage.removeItem(STORAGE_KEY)
}

export function dashboardPathForRole (roleid) {
  const id = Number(roleid)
  const map = {
    1: '/dashboard/admin',
    2: '/dashboard/school',
    3: '/dashboard/rater',
    4: '/dashboard/rater'
  }
  return map[id] || '/'
}
